// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.box-1-top-22{
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    gap: 30px;
}
.Image-box-Edituser{
    margin: 12px;
    width: 20%;
    border: 1px solid #c4c4c4;
    border-radius: 10px;
    padding: 10px;
}

.submit-btn-edituser{
    background: blue !important;
    color: #fff !important;
    margin-left: 10px !important;
    margin-top: 10px !important;

}

.image-container{
    max-width: 175px;
    height: 100px;
    width: 100%;
    margin-top: 10px;
    border-radius: 5px;
}

.date-box{
    width: 192px;
}

.image-box-2{
    margin: 12px;
    max-width: 304px;
    border: 1px solid #cacacb;
    border-radius: 7px;
    padding: 10px;

}
.image-inside{
    max-width: 283px;
    width: 100%;
    height: 75px;
    margin-top: 3px;
    object-fit: cover;
}
.image-section-box{
    margin: 12px;
    width: 20%;
    border: 1px solid #c4c4c4;
    border-radius: 7px;
    padding: 7px;
}


.button-box{
    background: blue !important;
    color: #fff !important;
    margin-left: 10px !important;
    margin-top: 10px !important;
}

.description-image-box{
    display: flex;
    align-items: flex-end;
    gap: 20px;
    margin-top: 25px;
    flex-wrap: wrap;

}

.image-input-class-22[type="file"] {
    height: auto;
    overflow: hidden;
    width: 100%;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 1;
    opacity: 0;
}

.image-input-class-22[type="file"]+.attach-icon {
  background: #fff;
  color: #000;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  font-family: 'Rubik', sans-serif;
  font-size: inherit;
  font-weight: 500;
  outline: none;
  position: relative;
  transition: all 0.3s;
  vertical-align: middle;
  width: 239px;
  text-align: left;
  height: 50px;
  display: flex !important;
  align-items: center;
  gap: 2px;
  padding-left: 0;
}

.ql-snow .ql-editor h1{
    font-size: 11px !important;
    font-weight: 100 !important;
}`, "",{"version":3,"sources":["webpack://./src/content/applications/Event/EditEvent/EditEvent.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,eAAe;IACf,qBAAqB;IACrB,SAAS;AACb;AACA;IACI,YAAY;IACZ,UAAU;IACV,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,2BAA2B;IAC3B,sBAAsB;IACtB,4BAA4B;IAC5B,2BAA2B;;AAE/B;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;;AAEjB;AACA;IACI,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,UAAU;IACV,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;AAChB;;;AAGA;IACI,2BAA2B;IAC3B,sBAAsB;IACtB,4BAA4B;IAC5B,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,SAAS;IACT,gBAAgB;IAChB,eAAe;;AAEnB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,UAAU;IACV,UAAU;AACd;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;IACI,0BAA0B;IAC1B,2BAA2B;AAC/B","sourcesContent":[".box-1-top-22{\n    display: flex;\n    flex-wrap: wrap;\n    align-items: flex-end;\n    gap: 30px;\n}\n.Image-box-Edituser{\n    margin: 12px;\n    width: 20%;\n    border: 1px solid #c4c4c4;\n    border-radius: 10px;\n    padding: 10px;\n}\n\n.submit-btn-edituser{\n    background: blue !important;\n    color: #fff !important;\n    margin-left: 10px !important;\n    margin-top: 10px !important;\n\n}\n\n.image-container{\n    max-width: 175px;\n    height: 100px;\n    width: 100%;\n    margin-top: 10px;\n    border-radius: 5px;\n}\n\n.date-box{\n    width: 192px;\n}\n\n.image-box-2{\n    margin: 12px;\n    max-width: 304px;\n    border: 1px solid #cacacb;\n    border-radius: 7px;\n    padding: 10px;\n\n}\n.image-inside{\n    max-width: 283px;\n    width: 100%;\n    height: 75px;\n    margin-top: 3px;\n    object-fit: cover;\n}\n.image-section-box{\n    margin: 12px;\n    width: 20%;\n    border: 1px solid #c4c4c4;\n    border-radius: 7px;\n    padding: 7px;\n}\n\n\n.button-box{\n    background: blue !important;\n    color: #fff !important;\n    margin-left: 10px !important;\n    margin-top: 10px !important;\n}\n\n.description-image-box{\n    display: flex;\n    align-items: flex-end;\n    gap: 20px;\n    margin-top: 25px;\n    flex-wrap: wrap;\n\n}\n\n.image-input-class-22[type=\"file\"] {\n    height: auto;\n    overflow: hidden;\n    width: 100%;\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    z-index: 1;\n    opacity: 0;\n}\n\n.image-input-class-22[type=\"file\"]+.attach-icon {\n  background: #fff;\n  color: #000;\n  border: none;\n  border-radius: 10px;\n  cursor: pointer;\n  font-family: 'Rubik', sans-serif;\n  font-size: inherit;\n  font-weight: 500;\n  outline: none;\n  position: relative;\n  transition: all 0.3s;\n  vertical-align: middle;\n  width: 239px;\n  text-align: left;\n  height: 50px;\n  display: flex !important;\n  align-items: center;\n  gap: 2px;\n  padding-left: 0;\n}\n\n.ql-snow .ql-editor h1{\n    font-size: 11px !important;\n    font-weight: 100 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
